import { takeEvery, put, fork, call } from 'redux-saga/effects';
import { Client } from 'utils/client';
import { AUDIT_GETTING, getAuditFailure, getAuditSuccess } from './actions';

export function* getAudit(action) {
    try {
        console.log("AuditSaga getAudit queryParam: "+ action.payload);
        // const data = yield call(Client.getData, "http://localhost:8090/api/v1/portal/audit"+action.payload);
        const data= yield call(Client.getData, "/api/v1/portal/audits"+action.payload);

        yield put(getAuditSuccess(data))
    } catch (error) {
        yield put(getAuditFailure(error))
    }
}


function* watchOnLoad() {
    yield takeEvery(AUDIT_GETTING, getAudit)
}

export function* auditSaga() {
    yield fork(watchOnLoad)
}

